import { useState } from 'react';
import styles from './OwnerModal.module.css';
export default function OwnerModal({ defaultOwner, handleSave, handleClose }: {defaultOwner: string | undefined, handleSave: (owner: string) => void, handleClose(): void}) {
    const [owner, setOwner] = useState(defaultOwner != undefined ? defaultOwner : '');
    const [error, setError] = useState(false);

    const isValidEmail = (email: string): boolean => {
        // Basic email regex that checks:
        // - Has characters before @
        // - Has @ symbol
        // - Has characters between @ and .
        // - Has . followed by domain (2+ chars)
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const validEmail = emailRegex.test(email.trim());
        validEmail ? setError(false) : setError(true);
        return validEmail;
      };

    const save = () => {
        if (!isValidEmail(owner)) {
            return;
        }
        handleSave(owner);
    }

    return(
        <div className={styles.backdrop}>
            <div className={styles.modal}>
                <h3>Change owner</h3>
                <label htmlFor="ownerEmail">Email address</label>
                <input type="email" name="ownerEmail" id="ownerEmail" defaultValue={owner} onChange={(e) => setOwner(e.target.value)} onBlur={(e) => {isValidEmail(e.target.value)}}/>
                {error && <p className='error_text'>Invalid email address</p>}
                <div className={styles.flex}>
                    <button type="button" className="button" onClick={() => save()}>Save</button>
                    <button type="button" className="button button_black" onClick={() => handleClose()}>Close</button>
                </div>
            </div>
        </div>
    )
} 